import { create } from "zustand";
import { Banner } from "@/services/banner.service.ts";

type BannerStore = {
  banners: Banner[];
  setBanners: (newBanners: Banner[]) => void;
};

export const useBannerStore = create<BannerStore>((set) => ({
  banners: [],
  setBanners: (newBanners) => set({ banners: newBanners }),
}));
